import validateFieldForPlaceholder from 'lib/validateFieldPlaceholder';
import moment from 'moment';
import React from 'react';

import RenderListTable from './RenderListTable';
import TableRenderer from './TableRenderer';
/*
----------------------------------
Render the table for objects, nested objects and lists
----------------------------------
This is the component which renders the objects, nested objects and lists
----------------------------------
*/
const RenderObjectRow = ({ data, label = '', config = [] }) => {
  let resp: any = [];

  // if empty object or null
  const isEmptyDictionary =
    data && typeof data === typeof {} && Object.keys(data).length === 0;
  if (!data || isEmptyDictionary) {
    resp.push(
      // if label is not empty then render the label
      label !== '' ? (
        <tr key={label}>
          <td> {label.split(/(?=[A-Z])/).join(' ')}</td>
          <td>{validateFieldForPlaceholder(null)}</td>
        </tr>
      ) : (
        <>{validateFieldForPlaceholder(null)}</>
      ),
    );
  }
  // if not empty object and config is not empty
  else if (!isEmptyDictionary && data && config.length > 0) {
    resp.push(<TableRenderer data={data} config={config} nested={true} />);
  }
  // if not empty object and config is empty
  else if (!isEmptyDictionary && data && config.length === 0) {
    let keys: any = Object.keys(data);
    keys.forEach((key) => {
      const isDictionary = typeof data[key] === typeof {};
      // More strict date validation to prevent numeric strings from being treated as dates
      const isDateType =
        !isDictionary &&
        typeof data[key] === 'string' &&
        // Check if it looks like a date string (contains date separators or month names)
        (data[key].includes('-') ||
          data[key].includes('/') ||
          data[key].includes(':') ||
          /jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/i.test(data[key])) &&
        moment(data[key]).isValid() &&
        typeof data[key] !== 'number';
      const isScreenshot = key === 'screenshot';

      // if key is createdDate, updatedDate, owner then skip
      if (key !== 'createdDate' && key !== 'updatedDate' && key !== 'owner') {
        // if key is list then render list table
        if (key === 'list') {
          resp.push(
            <RenderListTable
              list={data[key]}
              listConfig={data[key].config}
              name={key}
              nestedCall
            />,
          );
        } else {
          resp.push(
            <tr key={key}>
              <td>{key.split(/(?=[A-Z])/).join('')}</td>
              <td>
                {isScreenshot && (
                  <img
                    src={`data:image/jpeg;base64,${data[key]}`}
                    alt="screenshot"
                  />
                )}
                {isDictionary && (
                  <table>
                    <tbody>
                      <RenderObjectRow
                        data={data[key]}
                        label=""
                        config={config}
                      />
                    </tbody>
                  </table>
                )}
                {isDateType && moment(data[key]).format('lll')}
                {!isScreenshot &&
                  !isDictionary &&
                  !isDateType &&
                  validateFieldForPlaceholder(data[key])}
              </td>
            </tr>,
          );
        }
      }
    });
  }
  return <>{resp}</>;
};

export default RenderObjectRow;
